export const S3_PATH_DISPLAY_NAME: { [key: string]: string } = {
    "IncidentLogs": "Incident",
    "KnowledgeArticles": "Knowledge Articles"
}
//e.g. s3_path = ["bucket name", "app name", "sub name"] if index =[0,2] heading bucket name and sub name delimited by space
// export const CITATION_HEADINGS_FROM_S3_PATH_INDEX = [3]
export const CITATION_HEADINGS_PREFIX = ""

export const ACTIVE_SESSION_MINUTES = 120; //2 hours

export const GENERAL_SERVER_ERROR = 'Server or network may be busy. Please try again. Contact support staff if problem persist.'

export const COOKIE_NAME_LOGIN_ROLE = 'loggedInAs'

//list of classifications for selections
export const CLASSIFICATIONS_LIST: string[] = []

export const SEARCH_INPUT_PLACEHOLDER = "What's your query?"